export const LAST_USED_ENTITY_ID = 'last-entity-id'
export const LAST_USED_ACCOUNT_ID = 'last-account-id'
export const WAS_CARD_PROMO_SHOWN = 'was-card-promo-shown'
export const WAS_LANG_PROMO_SHOWN = 'was-lang-promo-shown'
// the user id is appended; the same key names the localStorage entry
export const SECURITY_NOTICE_DISMISSED_PREFIX = 'security-notice-dismissed-'
